import React, {useState} from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import { formatDate } from '../../../../util/datetime'
import { renderProcessName, renderStateName, renderTaskName } from '../../../process/util/names'
import { Comment } from '../../../process/component/instance-detail/CommentList'
import { CUSTOMER_PROCESS_INSTANCE_LIST } from '../../ui-definition/customer-ui'
import currentUserHasAccess from '../../../../util/widget-helper'
import {lifecycle} from 'recompose';

const ProcessCommentList = ({ processCommentList }) => {
    if (processCommentList.length === 0) {
        return null
    }
    return (
        <tr>
            <td colSpan="6" style={{
                border: '1px solid #eee',
            }}>
                <div>
                    {processCommentList.map(comment => {
                        return (<Comment comment={comment}/>)
                    })}
                </div>
            </td>
        </tr>
    )
}

const ProcessInstance = ({ processInstance, isVisible }) => {
    const viewLink = '/process/instance/view/' + processInstance.id
    return (
        <React.Fragment>
            <tr>
                <td>{renderProcessName(processInstance.processName)}</td>
                <td>{formatDate(processInstance.started)}</td>
                <td>{formatDate(processInstance.lastStatusChange)}</td>
                <td>{renderStateName(processInstance.currentStateName)}</td>
                <td>{renderTaskName(processInstance.currentTaskName)}</td>
                <td><Link to={viewLink}>view</Link></td>
            </tr>

            {isVisible &&
            <ProcessCommentList processCommentList={processInstance.processCommentList}/>
            }
        </React.Fragment>
    )
}

const ProcessInstanceList = ({ processInstanceList }) => {
    if (!currentUserHasAccess(CUSTOMER_PROCESS_INSTANCE_LIST)) {
        return null
    }

    if (!processInstanceList || processInstanceList.length === 0) {
        return null
    }

    const [isVisible, setIsVisible] = useState(false);

    const toggleComments = () => {
        setIsVisible(!isVisible)
    }

    return (
        <ContentBox title="Process">
            <Row>
                <Column size={12}>
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={toggleComments}>
                        load comments&#160;<i className="fa fa-comments"/>
                    </button>
                </Column>
            </Row>
            <Row top="M">
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                            <tr>
                                <th>Process</th>
                                <th>Started</th>
                                <th>Last Status Change</th>
                                <th>Current State</th>
                                <th>Current Task</th>
                                <th>View</th>
                            </tr>
                        </thead>
                        <tbody>
                            {processInstanceList.map(processInstance => {
                                return (
                                    <ProcessInstance
                                        key={processInstance.id}
                                        processInstance={processInstance}
                                        isVisible ={isVisible}
                                    />)
                            })}
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}

ProcessInstanceList.propTypes = {
    processInstanceList: PropTypes.array,
    findProcessComment: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount() {
        this.props.findProcessComment(this.props.customerId)
    }
})(ProcessInstanceList)




// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/ProcessInstanceList.js